import clsx from 'clsx';
import * as React from 'react';

export type FieldsetProps = React.ComponentPropsWithoutRef<'fieldset'> & {
    size?: 'small' | 'medium';
};

/**
 * A set of fields grouped together.
 */
export function Fieldset({
    ref,
    ...props
}: FieldsetProps & { ref?: React.ForwardedRef<HTMLFieldSetElement> }) {
    const { size = 'medium', ...rest } = props;
    return (
        <fieldset
            ref={ref}
            // We may support horizontal later
            aria-orientation="vertical"
            {...rest}
            className={clsx('flex flex-col', size === 'small' ? 'gap-2' : 'gap-5', props.className)}
        />
    );
}

export type LegendProps = React.ComponentPropsWithoutRef<'legend'>;

/**
 * A legend (descriptive label) for a fieldset.
 */
export function Legend({
    ref,
    ...props
}: LegendProps & { ref?: React.ForwardedRef<HTMLLegendElement> }) {
    return (
        <legend ref={ref} {...props} className={clsx('text-ui-heading-small', props.className)} />
    );
}
